/* eslint-disable @typescript-eslint/no-explicit-any */
export class LocalStorageCache {
    constructor(prefix = '') {
        this.prefix = prefix;
    }
    getKey(key) {
        return `${this.prefix}-${key}`;
    }
    get(key, defaultValue) {
        try {
            const json = localStorage.getItem(this.getKey(key));
            return json == null ? defaultValue : JSON.parse(json);
        }
        catch (error) {
            return defaultValue;
        }
    }
    set(key, value) {
        try {
            localStorage.setItem(this.getKey(key), JSON.stringify(value));
        }
        catch (error) {
            return;
        }
    }
}
export class MemoryCache {
    constructor() {
        this.map = {};
    }
    get(key, defaultValue) {
        return this.map[key] ? JSON.parse(this.map[key]) : defaultValue;
    }
    set(key, value) {
        this.map[key] = JSON.stringify(value);
    }
}
//# sourceMappingURL=Cache.js.map